import globalStore from '@/services/global.state';
import {getAdjustAttribution} from '@/utils/adjust';
import {http, getAttribution, getDeviceCode} from '@utils';
import {SafeAny} from '@components/types';

export const sendCode = (userPhone: string, notToken?: boolean) => {
  return http.post('app/sendCode', {userPhone, notToken});
};

export const userLogin = async (
  userPhone: string,
  code: string,
  userInviteCode?: string,
  isLogin: boolean = true,
  notToken?: boolean,
) => {
  const date: {[k: string]: any} = {
    userPhone,
    code,
    userInviteCode,
    ...getAttribution(userInviteCode),
  };
  if (!isLogin && globalStore.isWeb && !userInviteCode) {
    date.userInviteCode = localStorage.getItem('invitationCode') || undefined;
  }

  if (globalStore.isWeb) {
    const attr = getAdjustAttribution();
    if (attr && attr.adid) {
      date.isReport = attr?.tracker_name !== 'Organic';
      date.adid = attr?.adid || '';
    }
  }

  const deviceCode = await getDeviceCode(true);

  date.deviceCode = deviceCode;
  if (getAdjustAttribution()?.gps_adid) {
    date.gpsAdid = getAdjustAttribution()?.gps_adid;
  }

  if (notToken) {
    date.notToken = true;
  }

  return http.post<
    null,
    {
      token: string;
      isNewUser: boolean;
    }
  >('app/userLoginNew', date, {
    headers: {
      deviceCode,
    },
  });
};

export const passwordLogin = async (userPhone: string, password: string) => {
  const deviceCode = await getDeviceCode(true);
  const gpsAdid = getAdjustAttribution()?.gps_adid;
  const data = {} as SafeAny;
  if (gpsAdid) {
    data.gpsAdid = gpsAdid;
  }

  return http.post<null, string>('app/password/login', {
    userPhone,
    password,
    deviceCode,
    ...data,
  });
};

export const updatePassword = (password: string, otpCode: string) => {
  return http.post<null, string>('app/user/set/password', {
    password,
    code: otpCode,
  });
};
